import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import { useRecoilValue, useSetRecoilState } from "recoil";
import ProtectedComponent from "src/components/Permission";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { uploadingFile } from "src/recoil/atoms/global";
import { uploadedFilesState } from "src/recoil/atoms/uploadedFilesState";
import APP_ROUTES from "src/routes/routes";

const GroupNavigateButtons = ({ handleSubmitForm, ownerId, disabled, isSubmit, isRetry, getRedirectURL = () => APP_ROUTES.HOME }) => {
  const { t } = useTranslation("flight-simulator");
  const globalUploadingField = useRecoilValue(uploadingFile);
  const setUploadedFilesState = useSetRecoilState(uploadedFilesState);
  const navigate = usePatchedNavigate();
  return (
    <>
      <span
        role="button"
        className={classNames("btn btn-secondary width-by-px-200 height-by-px-38", { disabled: globalUploadingField || isSubmit })}
        onClick={() => {
          if (!globalUploadingField) {
            setUploadedFilesState([]);
            navigate(getRedirectURL());
          }
        }}
      >
        <span>{t("new.cancel")}</span>
      </span>
      <ProtectedComponent id="flight-simulator-create" ownerId={ownerId}>
        <button
          className="btn btn-primary width-by-px-200 height-by-px-38"
          onClick={handleSubmitForm}
          disabled={disabled || globalUploadingField}
        >
          {isSubmit ? <Spinner size="sm" /> : <span>{isRetry ? t("new.retry") : t("new.submit")}</span>}
        </button>
      </ProtectedComponent>
    </>
  );
};

export default GroupNavigateButtons;
